module.exports = __webpack_public_path__ + "img/devbay.43177b20.png";